// extracted by mini-css-extract-plugin
module.exports = {"content":"content-e4ff7f","block":"block-e4ff7f","contentText":"contentText-e4ff7f"};